module.exports = __webpack_public_path__ + "img/spring_trip-20160416-15.d5c83d20.jpg";